<template>
  <a-modal
      :visible="visible"
      @ok="handleOk"
      :maskClosable="false"
      @cancel="handleCancel"
      :confirm-loading="confirmLoading"
      width="80vw" centered
  >
    <template v-slot:title>
      专家列表
      <span style="color: red">（注意：休假中、触发回避条件等不符合条件的专家不会被列出）</span>
    </template>
    <a-card class="mb-3">
      <a-form-model :model="queryParam" class="exi_form v2"
                    :label-col="{ flex: '0 0 auto' }"
                    :wrapper-col="{ span: 24 }">
        <a-form-model-item label="身份证">
          <a-input placeholder="身份证" v-model="queryParam.idCard" style="width:250px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="姓名">
          <a-input placeholder="请输入完整姓名，多个专家以逗号隔开" v-model="queryParam.expertName"
                   style="width:250px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="采购品目名称" style="width: 350px">
          <a-input v-model="queryParam.purchaseItem" @click="openPurchaseItems" read-only
                   placeholder="采购品目名称"/>
        </a-form-model-item>
        <a-form-model-item label="应急状态" prop="emergencyFlag">
          <dict-cascader v-model="queryParam.emergencyFlag"
                         dictKey="expert_emergency"
                         placeholder="应急状态选择"
                         style="width: 100%"></dict-cascader>
        </a-form-model-item>
        <a-form-model-item label="地区">
          <dict-cascader v-model="queryParam.areaAddress"
                         dictKey="COUNTRY.CITY"
                         placeholder="地区选择"
                         style="width: 100%"
          />
        </a-form-model-item>
        <a-button type="primary" icon="search" @click="onSearch">查询</a-button>
        <a-button type="Default" @click="clearMethod">清空</a-button>
      </a-form-model>
    </a-card>
    <a-card>
      <template v-slot:title>
        <span style="color: red">已选专家：</span>
        <a-button-group size="small" class="ml-2 mt-2" v-for="(item) in userSelectContent">
          <a-button>{{ item.expertName }}</a-button>
          <a-button @click="removeMethod(item)" type="danger">
            <a-icon type="delete"></a-icon>
          </a-button>
        </a-button-group>
      </template>
      <s-table
          class="mt-4"
          ref="table"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,type: 'radio'}"
          :columns="columns"
          :pagination="taskPagination"
          :pageSize="pageSize"
          :data="loadData"
          :rowKey="record => record.id"
      >
        <template v-slot:expertName="record">
         <a  @click="onViewModal(record)">{{ record.expertName }}</a><span>
          {{record.idCard}}
        </span>
          <a-popover v-if="record.extras.applyByOpenDate && record.extras.applyByOpenDate.length>0"
                     :title="record.expertName+'专家同一天开标/活动时间项目列表'">
            <template v-slot:content>
              <a-list size="small" bordered :data-source="record.extras.applyByOpenDate">
                <a-list-item slot="renderItem" slot-scope="item, index">
                  <a-list-item-meta>
                    <div slot="description">开标/活动时间：{{ item.openDate|dayjs('YYYY-MM-DD HH:mm') }}
                      <a-tag :color="ExtractExpertFlagEnum.getValOrCol(item.expertFlag).color">
                        {{ ExtractExpertFlagEnum.getValOrCol(item.expertFlag).value }}
                      </a-tag>
                    </div>
                    <div slot="title">{{ item.projectName }}{{ item.projectCode ? '(' + item.projectCode + ')' : '' }}
                    </div>
                    <a-badge slot="avatar" status="success"/>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </template>
            <a>
              <a-icon style="margin-left: 5px" type="solution"/>
            </a>
          </a-popover>
        </template>
        <template v-slot:unitName="record">
          {{ record.extras.incumbencyText }}<br>
          {{ record.unitName }}
        </template>
        <template v-slot:tagName="record">
          <a-tag class="mt-1"
                 v-for="(it, index) in record.extras.tagInfos"
                 :key="it.id"
                 :title="it.tagDetail"
                 :color="it.tagColor">
            {{ it.tagName }}
          </a-tag>
          <a-tag class="mt-1" v-if="record.emergencyFlag==='1'"
                 color="red">
            {{ record.extras.emergencyFlagText }}
          </a-tag>
        </template>
      </s-table>
    </a-card>
    <choose-search-purchase-item ref="items" :visible="purchaseVisible"
                                 @success="purchaseSuccess"
                                 @cancel="purchaseVisible=false"/>
    <expertView-modal ref="expertView"
                      :visible="evmVisible"
                      :fromType="ExpertFromType.EXPERT_LIST"
                      @success="evmVisible = false"
                      @openEdit="openEdit"
                      @cancel="evmVisible = false"/>
    <expert-edit ref="expertEditRef" @openViewExpert="openViewExpert"/>
  </a-modal>

</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import { QueryAppointExpertInfo } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import { AppointExtractExpert, ReplaceExtractExpert } from '@/epp/expertmain/selectexpertapply/api/ExpertApplyRequest'
import { ExpertFromType, ExpertState } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import ChooseSearchPurchaseItem from '@/epp/expertmain/purchaseitems/ChooseSearchPurchaseItem.vue'
import DictCascader from '@/components/dict/DictCascader.vue'
import { GetAllTagList } from '@/epp/expertmain/experttag/util/TagUtil'
import { ExtractExpertFlagEnum, GetCityFromLocation } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'
import expertViewModal from '@/epp/expertmain/expertInfo/common/ExpertViewModal.vue'
import ExpertEdit from '@/epp/expertmain/expertInfo/ExpertEdit.vue'

export default {
  name: 'ReplaceExtractExpertModal',
  computed: {
    ExpertFromType () {
      return ExpertFromType
    },
    ExtractExpertFlagEnum () {
      return ExtractExpertFlagEnum
    }
  },
  components: {
    ExpertEdit,
    expertViewModal,
    DictCascader,
    ChooseSearchPurchaseItem,
    PageView,
    STable
  },
  mounted () {
  },
  watch: {
    visible (val) {
      if (val) {
        if (this.$refs.table) {
          this.clearMethod()
          this.copyData = []
          this.userSelectContent = []//用户勾选的内容
          this.selectedRowKeys = []
        }
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    applyId: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 5
    },
    pageSizeOptions: {
      type: Array,
      default () {
        return ['5', '10']
      }
    }
  },
  data () {
    return {
      taskPagination: {
        showTotal: total => `共 ${total} 条`,
        size: 'small',
        pageSizeOptions: this.pageSizeOptions
      },
      userSelectContent: [],//用户勾选的内容
      selectedRowKeys: [],
      columns: [
        {
          title: '专家名称',
          width: '12%',
          scopedSlots: { customRender: 'expertName' }
        },
        {
          title: '手机号',
          width: '10%',
          dataIndex: 'mobilePhone'
        },
        {
          title: '年龄',
          dataIndex: 'extras.expertage',
        },
        {
          title: '标签',
          width: '8%',
          align: 'left',
          scopedSlots: { customRender: 'tagName' }
        },
        {
          title: '区域',
          width: '8%',
          dataIndex: 'extras.areaAddressText',
          customRender: (text) => {
            return GetCityFromLocation(text)
          }
        },
        {
          title: '单位名称',
          width: '15%',
          align: 'left',
          scopedSlots: { customRender: 'unitName' }
        },
        {
          title: '品目名称',
          dataIndex: 'purchaseItem'
        },
      ],
      queryParam: {
        purchaseItem: undefined,
        purchaseItemId: undefined,
        purchaseItemCode: undefined,
      },
      defaultParam: {
        applyId: this.applyId,
        state: ExpertState.STATE.IN_SUCCESS,
      },
      confirmLoading: false,
      loadData: async parameter => {
        const params = { ...parameter, ...this.defaultParam, ...this.queryParam }
        return QueryAppointExpertInfo(params)
      },
      purchaseVisible: false,
      tagList: [],
      extractId: undefined,
      evmVisible: false,
      openEditExpertId: undefined,
    }
  },
  created () {
    this.getTagList()
  },
  methods: {
    //初始化数据
    onLoadData (extractId) {
      this.extractId = extractId
    },
    //获取标签列表
    async getTagList () {
      this.tagList = await GetAllTagList()
    },
    //确认后数据传回调用方
    async handleOk () {
      try {
        this.confirmLoading = true
        let num = this.selectedRowKeys.length
        if (num === 0) {
          this.$message.error('请选择替换专家！')
          return
        }
        let data = {
          applyId: this.applyId,
          extractId: this.extractId,
          expertId: this.selectedRowKeys[0]
        }
        let res = await ReplaceExtractExpert(data)
        if (200 !== res.code) {
          this.$message.error('替换失败！')
          return
        }
        this.$emit('success')
        this.$message.success('替换成功！')
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.confirmLoading = false
      }
    },
    //关闭窗口
    handleCancel () {
      this.$emit('cancel')
    },
    //清空的方法
    clearMethod () {
      this.queryParam = {}
      this.onSearch()
    },
    //选择专家
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.userSelectContent = selectedRows
    },
    //查询
    onSearch () {
      this.$refs.table.refresh(true)
    },
    //重置
    removeMethod (data) {
      this.userSelectContent = this.userSelectContent.filter(item => item.id !== data.id)
      this.selectedRowKeys = this.selectedRowKeys.filter(item => item !== data.id)
    },
    //打开采购品目
    openPurchaseItems () {
      this.purchaseVisible = true
      let result = []
      if (this.queryParam.purchaseItem) {
        const data = {}
        data['fid'] = this.queryParam.purchaseItemId
        data['fspmmc'] = this.queryParam.purchaseItem
        data['fspmbm'] = this.queryParam.purchaseItemCode
        result.push(data)
      }
      this.$refs.items.preView(result)
    },
    //采购品目选择成功后
    purchaseSuccess (purchaseItem) {
      this.purchaseVisible = false
      this.queryParam.purchaseItem = undefined
      this.queryParam.purchaseItemId = undefined
      this.queryParam.purchaseItemCode = undefined
      if (purchaseItem.length > 0) {
        let data = purchaseItem[0]
        this.queryParam.purchaseItem = data.fspmmc
        this.queryParam.purchaseItemId = data.fid
        this.queryParam.purchaseItemCode = data.fspmbm
      }
    },
    //打开窗口查看信息
    onViewModal (record) {
      this.evmVisible = true
      this.$refs.expertView.loadData(record.id)
    },
    //关闭修改或保存修改后打开窗口查看信息
    openViewExpert () {
      this.evmVisible = true
      this.$refs.expertView.loadData(this.openEditExpertId)
      //刷新
      this.$refs.table.refresh(false)
    },
    openEdit (id) {
      this.openEditExpertId = id
      this.$refs.expertEditRef.loadData(id)
    },
  }
}
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 24px;
}

.close-span:hover {
  cursor: pointer;
}
/deep/.ant-table-thead > tr > th, /deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
  overflow-wrap: break-word;
}
</style>
